import { render, staticRenderFns } from "./PromotionPage.vue?vue&type=template&id=8bb2852c&scoped=true"
import script from "./PromotionPage.vue?vue&type=script&lang=js"
export * from "./PromotionPage.vue?vue&type=script&lang=js"
import style0 from "./PromotionPage.vue?vue&type=style&index=0&id=8bb2852c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb2852c",
  null
  
)

export default component.exports